/**
 * BrandMark — логотип Skrezo (значок + опциональный вордмарк).
 * Плейсхолдер под финальный бренд. Значок красится в `--primary`,
 * поэтому совпадает с брендовым акцентом темы.
 */

import {cn} from '@lib/utils';

type BrandMarkProps = {
  size?: number;
  showWordmark?: boolean;
  className?: string;
};

export const BrandMark = ({size = 28, showWordmark = true, className}: BrandMarkProps) => (
  <div className={cn('inline-flex items-center gap-2.5', className)}>
    <span
      className="grid place-items-center rounded-[30%] bg-primary font-bold leading-none text-primary-foreground"
      style={{width: size, height: size, fontSize: size * 0.56}}
    >
      S
    </span>
    {showWordmark && (
      <span className="text-[17px] font-extrabold tracking-tight text-foreground">Skrezo</span>
    )}
  </div>
);
